import {
  discoveryApiRef,
  fetchApiRef,
  ApiBlueprint,
  createFrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { IntegrationsApiClient, integrationsApiRef } from './api';
import { rootRouteRef } from './routes';
import tabs from './tabs';

const integrationsApi = ApiBlueprint.make({
  name: 'integrationsApi',
  params: defineParams =>
    defineParams({
      api: integrationsApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new IntegrationsApiClient({ discoveryApi, fetchApi }),
    }),
});

export const catalogDevopsModuleIntegrationsPlugin = createFrontendPlugin({
  pluginId: 'catalog-devops-module-integrations',
  routes: {
    root: rootRouteRef,
  },
  extensions: [integrationsApi, ...tabs],
});
